$(document).ready(function () {
  $(".quantity_button").on("click", function () {
    const quantitySectionId = $(this)
      .closest(".quantity_buttons")
      .data("section-id");
    const quantityFormId = $(this).closest(".quantity_buttons").data("form-id");
    $(".qty-selected").children(".quantity__input").attr("id", "");
    $(".qty-selected").children(".quantity__input").attr("form", "");
    $(".quantity_button").not(this).removeClass("qty-selected");
    $(this).addClass("qty-selected");

    $(this).children(".quantity__input").attr("id", quantitySectionId);
    $(this).children(".quantity__input").attr("form", quantityFormId);
  });
  var acc = document.getElementsByClassName("custom-accordion");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }
  $(".jumpto--variant").on("click", function () {
    // Get the target element's offset from the top
    var targetOffset = $("variant-radios").offset().top - 100;

    // Smoothly scroll to the target element
    $("html, body").animate(
      {
        scrollTop: targetOffset,
      },
      1000
    ); // Adjust the duration as needed
  });
  $(".jumpto--bundle").on("click", function () {
    // Get the target element's offset from the top
    var targetOffset = $("#bundle-slider").offset().top + 40;

    // Smoothly scroll to the target element
    $("html, body").animate(
      {
        scrollTop: targetOffset,
      },
      1000
    ); // Adjust the duration as needed
  });

  /*var element = $("#shopify-section-scrolling-announcement-bar");

  $(window).scroll(function () {
    var rect = element[0].getBoundingClientRect();

    if (rect.top <= 0) {
      element.css({
        position: "sticky",
        top: "0",
      });
    } else {
      element.css({
        position: "static",
      });
    }
  });*/
});


jQuery(document).on("click",".shop-button-landing",function(){
   var targetOffset = $("#landing-featured-product--").offset().top;
    // Smoothly scroll to the target element
    $("html, body").animate({
        scrollTop: targetOffset - 150
    });
});

jQuery(document).on("click",'.variant-feature-list',function(){
  var objthis = jQuery(this);
  setTimeout(function(){
    var phandle = objthis.siblings("[type='radio']:checked").attr('data-phandle');
    var valueAddons = objthis.siblings("[type='radio']:checked").attr('data-option-value');
    var nameGetOpt = objthis.siblings("[type='radio']:checked").attr('name');
    var extraOffText = jQuery('label[data-option-value="'+valueAddons+'"]').find('.badge-savings.savings-normale .price-value').text();
    var setextraOffText='';
    if(extraOffText==""){
      setextraOffText=jQuery('label[data-option-value="'+valueAddons+'"]').find('.variant-features .variant-feature-text').text();
    }else{
      extraOffText = extraOffText.replace('off','');
      setextraOffText = 'Save an extra '+extraOffText;
    }
    if(nameGetOpt=='Add An IcePod?'){
      jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').text(setextraOffText);
      if(valueAddons == 'no' && phandle == 'the-water-chiller'){
        jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').hide();
      }
    }
  },200);
  //jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').hide();
});
jQuery(document).ready(function(){
  console.log("ddfdfd");
  //jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').hide();
  setTimeout(function(){
    var valueAddons = jQuery('.stacked-options').find("[name='Add An IcePod?']:checked").attr('data-option-value');
    var nameGetOpt = jQuery('.stacked-options').find("[name='Add An IcePod?']:checked").val();
    var phandle = jQuery('.stacked-options').find("[name='Add An IcePod?']:checked").attr('data-phandle');
    console.log("nameGetOpt--->",nameGetOpt);
    if(nameGetOpt!=undefined){
      nameGetOpt = nameGetOpt.replace(' ','-');
      nameGetOpt=nameGetOpt.toLowerCase();
      var extraOffText = jQuery('label[data-option-value="'+nameGetOpt+'"]').find('.badge-savings.savings-normale .price-value').text();
      var setextraOffText='';
      if(extraOffText==""){
        setextraOffText=jQuery('label[data-option-value="'+nameGetOpt+'"]').find('.variant-features .variant-feature-text').text();
      }else{
        extraOffText = extraOffText.replace('off','');
        setextraOffText = 'Save an extra '+extraOffText;
      }
      console.log("nameGetOpt",nameGetOpt,extraOffText);
      //if(nameGetOpt=='Add An IcePod?'){
      //console.log("setextraOffText",setextraOffText);
        jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').text(setextraOffText);
      //}
      if(valueAddons == 'no' && phandle == 'the-water-chiller'){
        jQuery('.js.product-form__input.stacked-options-layout').eq(1).find('.form_small__label').hide();
      }
    }
  },10);
});
var interBanner = setInterval(function(){
  if(jQuery(window).width()>767){
    if(jQuery('.featured-collection-slider .mobiles--slide-banner').length>0){
      jQuery('.featured-collection-slider .mobiles--slide-banner').remove();
      clearInterval(interBanner);
    }
  }
});

// Chiller Calculator -- START
$(document).ready(function() {
 $('.quantity-box-wrapper').each(function () {
    var $wrapper = $(this);
    var $input = $wrapper.find('.quantity-input-box input');
    var $plusBtn = $wrapper.find('.add-quantity');
    var $minusBtn = $wrapper.find('.minus-quantity');
  
    $plusBtn.on('click', function () {
      var current = parseInt($input.val()) || 0;
      $input.val(current + 1);
    });
  
    $minusBtn.on('click', function () {
      var current = parseInt($input.val()) || 0;
      if (current > 1) {
        $input.val(current - 1);
      }
    });
  });
});

// Code to run after delay
function openSavingsModal() {
  $(".calculate-savings-modal.calculat-box").addClass("show");
  $(".calculate-savings-modal-overlaly").addClass("show");
}

function closeSavingsModal() {
  $(".calculate-savings-modal").removeClass("show");
  $(".calculate-savings-modal-overlaly").removeClass("show");
}

function showCalculationResult() {
  $(".calculate-savings-modal.calculat-box").removeClass("show");
  $(".calculate-savings-modal.calculat-result-box").addClass("show");
  $(".calculate-savings-modal .calculate-saving-button .loader").removeClass("show");
  
  var $checked = $('input[name="chiller__calculate"]:checked');
  var chillerPrice = $checked.data('value');
  var chillerQty = $('#quantity_chiller').val();

  var iceBagCost = 15;
  var weeksPerYear = 52;
  var totalIceBaths = chillerPrice / iceBagCost;
  var totalWeek = Math.ceil(totalIceBaths / chillerQty);
  $('.chiller__daycount span').html(eval(totalWeek) * 7);

  $('.chiller__hourcount strong').html(eval(chillerQty) * 2 * 52+ ' hours');

  // Calculation 2: How much do you save per year?
  var yearlyIceCost = chillerQty * iceBagCost * weeksPerYear;
  var chillersavings = yearlyIceCost - chillerPrice;
  var finalChillerPrice = eval(chillersavings) * 100;
  finalChillerPrice = Shopify.formatMoney(finalChillerPrice);
  finalChillerPrice = finalChillerPrice.replace('.00','');
  $('.chiller__saveprice span').html(finalChillerPrice);
}

function calculateAgain() {
  $(".calculate-savings-modal.calculat-box").addClass("show");
  $(".calculate-savings-modal.calculat-result-box").removeClass("show");
}

$(".calc-saving-price-btn button").click(openSavingsModal);
$(".calculate-savings-modal .modal-close-btn").click(closeSavingsModal);
$(".calculate-savings-modal .calculate-saving-button").click(function(){
  $(this).find('.loader').addClass('show');
  setTimeout(function () {
      showCalculationResult();
  }, 1500);
});
$(".calculate-savings-modal .calculate-again-button").click(calculateAgain);

$('.chiller_popup_close').click(closeSavingsModal);

if(document.getElementById("quantity_chiller")!=null){
  document.getElementById("quantity_chiller").addEventListener("input", function () {
    if (this.value < 1) {
      this.value = 1;
    }
  });
}

$(document).on('click', '.calculate-savings-modal-overlaly', function () {
  $('.calculate-savings-modal-overlaly').removeClass('show');
  $('.calculate-savings-modal').removeClass('show');
});

// Chiller Calculator -- END


// Universal Chiller Tab -- START
document.addEventListener("DOMContentLoaded", function () {
  const firstAccordionItemHeader = document.querySelector(
    ".universal_tab_header"
  );
  
  if(firstAccordionItemHeader!=null){
    const firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;
  }
  // Open the first accordion item by default
  // firstAccordionItemHeader.classList.add("active");
  // firstAccordionItemBody.style.maxHeight =
  //   firstAccordionItemBody.scrollHeight + "px";

  const accordionItemHeaders = document.querySelectorAll(
    ".universal_tab_header"
  );

  accordionItemHeaders.forEach((accordionItemHeader) => {
    accordionItemHeader.addEventListener("click", (event) => {
      const currentlyActiveAccordionItemHeader = document.querySelector(
        ".universal_tab_header.active"
      );
      if (
        currentlyActiveAccordionItemHeader &&
        currentlyActiveAccordionItemHeader !== accordionItemHeader
      ) {
        currentlyActiveAccordionItemHeader.classList.toggle("active");
        currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
      }
      accordionItemHeader.classList.toggle("active");
      const accordionItemBody = accordionItemHeader.nextElementSibling;
      if (accordionItemHeader.classList.contains("active")) {
        accordionItemBody.style.maxHeight =
          accordionItemBody.scrollHeight + "px";
      } else {
        accordionItemBody.style.maxHeight = 0;
      }
    });
  });
});
// Universal Chiller Tab -- END

/*************************** CART DRAWER UPSELL PRODUCT ADD FOR EMPTY CART TO CALL THIS JS START *************************/
jQuery(document).on('click',".upcart-cart .upcart-upsells-button",function (e) {
  const upsellBtn = jQuery(this);
  if (upsellBtn) {
    const interval = setInterval(() => {
      $.getJSON('/cart.js', function(cart) {
        if(cart.items.length==1){
          if (cart.items && cart.items.length > 0) {
            upcartOnAddToCartUpdateFirst(cart);
            clearInterval(interval);
          }
        }else if(cart.items.length>1){
          clearInterval(interval);
        }
      });
    }, 500);
  }
});
function upcartOnAddToCartUpdateFirst(cart) {
  if (!Array.isArray(window.preOrderProducts)) return;

  window.preOrderProducts.forEach(({ handle, variant_id, preOrderText }) => {
    if (!preOrderText) return;

    const PROPERTY_KEY = "Pre-order";
    const PROPERTY_VALUE = preOrderText;

    const targetItem = cart.items.find(
      item =>
        item.variant_id === variant_id &&
        (!item.properties || item.properties[PROPERTY_KEY] !== PROPERTY_VALUE)
    );

    if (targetItem) {
      const newProperties = {
        ...(targetItem.properties || {}),
        [PROPERTY_KEY]: PROPERTY_VALUE
      };

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: targetItem.key,
          quantity: 0
        })
      }).then(() => {
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variant_id,
            quantity: targetItem.quantity,
            properties: newProperties
          })
        }).then(() => {
          if (window.UpCart?.refreshCart) {
            window.UpCart.refreshCart();
          }
        });
      });
    }
  });
}
/*************************** CART DRAWER UPSELL PRODUCT ADD FOR EMPTY CART TO CALL THIS JS END *************************/